
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rewriting/formal-rewriting",
      function () {
        return require("private-next-pages/rewriting/formal-rewriting.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rewriting/formal-rewriting"])
      });
    }
  